// extracted by mini-css-extract-plugin
module.exports = {"table-shape-item":"table-shape-item___1zLfS","disabled":"disabled___3OAmg"};